"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIMUM_DAYS_DQ_TO_BE_REFERRED_TO_COLLECTIONS = exports.ThirdPartyDebtCollectionSftpDirection = exports.ThirdPartyDebtCollectionTape = exports.ThirdPartyReferralReason = exports.ThirdPartyReferralStatus = exports.ThirdPartyDebtCollector = void 0;
/** @TranslateToPython */
var ThirdPartyDebtCollector;
(function (ThirdPartyDebtCollector) {
    ThirdPartyDebtCollector["GoalSolutions"] = "GoalSolutions";
})(ThirdPartyDebtCollector || (exports.ThirdPartyDebtCollector = ThirdPartyDebtCollector = {}));
/** @TranslateToPython */
var ThirdPartyReferralStatus;
(function (ThirdPartyReferralStatus) {
    ThirdPartyReferralStatus["active"] = "active";
    ThirdPartyReferralStatus["settled"] = "settled";
    ThirdPartyReferralStatus["paidInFull"] = "paidInFull";
    ThirdPartyReferralStatus["completed"] = "completed";
})(ThirdPartyReferralStatus || (exports.ThirdPartyReferralStatus = ThirdPartyReferralStatus = {}));
/** @TranslateToPython */
var ThirdPartyReferralReason;
(function (ThirdPartyReferralReason) {
    ThirdPartyReferralReason["ChargedOff"] = "ChargedOff";
    ThirdPartyReferralReason["Delinquent"] = "Delinquent";
})(ThirdPartyReferralReason || (exports.ThirdPartyReferralReason = ThirdPartyReferralReason = {}));
/** @TranslateToPython */
var ThirdPartyDebtCollectionTape;
(function (ThirdPartyDebtCollectionTape) {
    ThirdPartyDebtCollectionTape["Delinquent"] = "Delinquent";
    ThirdPartyDebtCollectionTape["ChargedOff"] = "ChargedOff";
})(ThirdPartyDebtCollectionTape || (exports.ThirdPartyDebtCollectionTape = ThirdPartyDebtCollectionTape = {}));
/** @TranslateToPython */
var ThirdPartyDebtCollectionSftpDirection;
(function (ThirdPartyDebtCollectionSftpDirection) {
    ThirdPartyDebtCollectionSftpDirection["Upload"] = "Upload";
    ThirdPartyDebtCollectionSftpDirection["Download"] = "Download";
})(ThirdPartyDebtCollectionSftpDirection || (exports.ThirdPartyDebtCollectionSftpDirection = ThirdPartyDebtCollectionSftpDirection = {}));
exports.MINIMUM_DAYS_DQ_TO_BE_REFERRED_TO_COLLECTIONS = 60;
